window._spring = {
  context_path: (document.getElementsByTagName('meta')['spring-context-path'].getAttribute('content') || '').replace(
    /\/$/,
    '',
  ),
};

window.$_spring = window._spring;
